var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`contentElement__${_vm.side}Number`},_vm._l((_vm.countInWords),function(word,index){return _c('span',{key:word,class:`contentElement__${_vm.side}NumberDigit -${word}`},[_vm._v("\n        "+_vm._s(index + 1)+"\n    ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }